export default function convertToHoursAndMinutes(minutes) {

    if(!minutes) return null

    let hours = Math.floor(minutes / 60)
    let remainingMinutes = Math.floor(minutes % 60);

    return ({hours, minutes: remainingMinutes})
}